module.exports = __webpack_public_path__ + "static/zebratowel-903d8544da573c5ebca4f8c3f1761783.png";